import React from 'react';
import './EmbedScreenCheck.css';
import Tabs from '../../components/Tabs';
import Logout from '../../assets/logout.png';
import SDLogo from '../../assets/sd-logo-white.svg';
import Logo from '../../assets/Logo.svg';
import {connect} from 'react-redux';
import { logoutRequest } from '../../store/action/logoutAction';

const EmbedScreenCheck = ({...props}) => {

    const handleLogout=()=>{
      props.logout();
    }

  return (
    <div className="layout">
        <div className='navbar'>
          <div className='navbar-logo'>{props.icon && props.icon["data"]["dashboard_logo"] ? <img src={props.icon["data"]["dashboard_logo"]} alt="custom-logo" width="150px" height="45px"/>:
          <img src={SDLogo} alt="logo" width="140px" height="45px"/>}</div>
          <div className='logout' onClick={handleLogout}>
            <p>Logout</p>
            <img src={Logout} alt="logout"/>
          </div>
        </div>
        <Tabs/>
        <div className='powered'><p>Powered By</p> <img src={Logo} alt="logo" width="35" height="30"/></div>
    </div>
      
  )
}

const mapStateToProps=(state) => ({
  icon: state.loginReducer.userData,
})

const mapDispatchToProps = (dispatch) => ({
  logout: () =>
    dispatch(logoutRequest()),
});

export default connect(mapStateToProps,mapDispatchToProps)(EmbedScreenCheck);